import { Box, Button, List, Row, Text, Title } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const RateConfigurationSection = ({
  hasPerDiemsFeature,
  hasNewPerDiemFeature,
  hideTitle = false,
}: {
  hasPerDiemsFeature: boolean
  hasNewPerDiemFeature: boolean
  hideTitle?: boolean
}) => {
  const { navigation } = useNavigation()

  const trackEvent = () => {
    track(trackingEvents.expenses.goToPerDiemRatesConfig)
  }

  const trackMileageRatesEvent = () => {
    track(trackingEvents.expenses.goToMileageRatesConfig)
  }

  const trackGermanyPerDiemRatesEvent = () => {
    track(trackingEvents.expenses.goToPerDiemRatesConfig, {
      type: 'germany',
    })
  }

  return (
    <Box flexGrow>
      <Row>
        {!hideTitle && (
          <Row.Col halfWidth>
            <Title
              variant="400"
              title={i18n.t('expenses_v2.settings.rate_configurations.title')}
              description={i18n.t('expenses_v2.settings.rate_configurations.description')}
              illustration="cash"
            />
          </Row.Col>
        )}
        <Row.Col halfWidth>
          <List>
            {hasPerDiemsFeature && (
              <List.Item>
                <Box
                  flexDirection="row"
                  justifyContent="spaceBetween"
                  alignItems="center"
                  width="full"
                >
                  <Text.Normal weight="semibold">
                    {i18n.t('expenses_v2.settings.rate_configurations.per_diem_title')}
                  </Text.Normal>
                  <Button.Router
                    to={navigation.settings.expenses.rateConfigurations.fullPath()}
                    type="secondary"
                    aria-label={i18n.t('expenses_v2.settings.rate_configurations.cta_label')}
                    iconName="arrow-right"
                    onClick={() => trackEvent()}
                  />
                </Box>
              </List.Item>
            )}
            {hasNewPerDiemFeature && (
              <List.Item>
                <Box
                  flexDirection="row"
                  justifyContent="spaceBetween"
                  alignItems="center"
                  width="full"
                >
                  <Text.Normal weight="semibold">
                    {i18n.t('expenses_v2.settings.rate_configurations.germany_per_diem_title')}
                  </Text.Normal>
                  <Button.Router
                    to={navigation.settings.expenses.perdiemRates.fullPath()}
                    type="secondary"
                    aria-label={i18n.t(
                      'expenses_v2.settings.rate_configurations.go_to_germany_per_diem_rates'
                    )}
                    iconName="arrow-right"
                    onClick={() => trackGermanyPerDiemRatesEvent()}
                  />
                </Box>
              </List.Item>
            )}
            <List.Item>
              <Box
                flexDirection="row"
                justifyContent="spaceBetween"
                alignItems="center"
                width="full"
              >
                <Text.Normal weight="semibold">
                  {i18n.t('expenses_v2.settings.rate_configurations.mileage_title')}
                </Text.Normal>
                <Button.Router
                  to={navigation.settings.expenses.mileageRates.fullPath()}
                  type="secondary"
                  aria-label={i18n.t(
                    'expenses_v2.settings.rate_configurations.go_to_mileage_rates'
                  )}
                  iconName="arrow-right"
                  onClick={() => trackMileageRatesEvent()}
                />
              </Box>
            </List.Item>
          </List>
        </Row.Col>
      </Row>
    </Box>
  )
}

export default RateConfigurationSection
